import React from 'react'
import axios  from 'axios'

const Context = React.createContext();

export class Provider extends React.Component 
{

    state ={
         articles : [],
         heading: 'Trending news'
    }

    componentDidMount(){
    console.log("fetching data")
        axios.get(`https://newsapi.org/v2/top-headlines?country=us&category=technology&apiKey=${process.env.REACT_APP_MM_KEY}`)
            .then(res => {
             //console.log(res.data);
           // console.log(res.data.articles);
                this.setState({
                    articles : res.data.articles});
            })
            .catch(err=> console.log(err));
    }
    render(){
        return(
            <Context.Provider value={this.state}>
                 {this.props.children}
            </Context.Provider>
        )
    }
}


export const Consumer = Context.Consumer